import { render, staticRenderFns } from "./fb-age-series.vue?vue&type=template&id=3e1d803a&scoped=true"
import script from "./fb-age-series.vue?vue&type=script&lang=js"
export * from "./fb-age-series.vue?vue&type=script&lang=js"
import style0 from "./fb-age-series.vue?vue&type=style&index=0&id=3e1d803a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1d803a",
  null
  
)

export default component.exports